const onboardingFormData = [
  /* PERSONAL FORM */
  {
    id: 1,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },
  /* IBAN */
  {
    id: 2,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },
  /* IDENTITY DOCUMENTS */
  {
    id: 3,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },

  /* SUMMARY INFO */
  {
    id: 4,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },
  /* CONSUMER SUMMARY */
  {
    id: 5,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },

  /* POWER OF ATTORNEY */
  {
    id: 6,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },

  /* CONFIRM REGISTRATION */
  {
    id: 7,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },

  /* AML FORM */
  {
    id: 8,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },

  /* FINAL STEP */
  {
    id: 8.5,
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
  },
];

export default onboardingFormData;
